import { toast } from "src/shadcn/ui/use-toast";
import { useCentralAPI, UserCacheType, WorkItemTypeCentral } from "./centralAPI";
import { Project, User } from "src/types";
import { useWorkItemsAPI, WorkItemRevisionsResponse } from "./central.workItem";
import { useRestAPI } from "./axiosAPI";
import { calculateWorkingHours } from "src/pages/LayoutRoot/pages/Master/my_works/component.projectCard";

export function useProjectsAPI() {

    const {
        centralData,
        isFetching,
        isFetched,
        isError,
        error
    } = useCentralAPI({
        trigger: false
    });

    type props = {
        filters?: {
            organizationIds?: string[],
            projectStatus?: 'completed' | 'inProgress' | 'onHold' | 'dropped'
        },
        sortBy?: 'latestEditedFirst' | 'largeUncompletedFirst'
    }

    const listProjects = ({
        filters = {
            organizationIds: undefined,
            projectStatus: undefined
        },
        sortBy = 'largeUncompletedFirst'
    }: props) => {


        if (!centralData) return []
        console.log(filters)
        const filteredProjects = centralData?.Projects.filter((project) => {
            if (!filters.organizationIds || filters.organizationIds.includes(project.organizationId)) {


                if (filters.projectStatus === 'completed' && project.projectStatus != 'completed') {
                    return false
                }

                if (filters.projectStatus === 'inProgress' && project.projectStatus != 'inProgress') {
                    return false
                }
                if (filters.projectStatus === 'onHold' && project.projectStatus != 'onHold') {
                    return false
                }
                if (filters.projectStatus === 'dropped' && project.projectStatus != 'dropped') {
                    return false
                }

                return true
            }

            return false

        })


        let sortedProjects: Project[] = []

        if (sortBy === 'latestEditedFirst') {
            sortedProjects = filteredProjects.sort((a, b) => new Date(b.lastUpdateTime).getTime() - new Date(a.lastUpdateTime).getTime())
        }

        if (sortBy === 'largeUncompletedFirst') {
            sortedProjects = filteredProjects.sort((a, b) => (b.totalWorkItem - b.completedWorkItem) - (a.totalWorkItem - a.completedWorkItem))
        }

        const projects = sortedProjects.map(project => {

            const users = centralData?.Users.filter((user) => user.projects.find((projectData) => projectData.id === project.id))
            const userArray: UserCacheType[] = []
            users.forEach(
                user => {
                    const projectData = user.projects.find((projectData) => projectData.id === project.id)

                    userArray.push({
                        ...user,
                        totalWorkItem: projectData?.totalWorkItem || 0,
                        completedWorkItem: projectData?.completedWorkItem || 0
                    })

                }
            )
            return ({ ...project, users: userArray })
        }) || []
        return projects
    }

    const getProjectsByUserId = ({ userOriginId, filter }: {
        userOriginId: string,
        filter?: {
            projectStatus?: 'completed' | 'inProgress' | 'onHold' | 'dropped',
        }
    }) => {

        const user = centralData?.Users.find((user) => user.user.originId === userOriginId)

        if (!user) return []
        let projects: (Project & { userTotalWorkItems: number, userCompletedWorkItems: number, workItems: WorkItemTypeCentral[] })[] = []

        user.projects.forEach(project => {
            const projectData = centralData?.Projects.find((projectData) => projectData.id === project.id)
            //load all work items
            const workItems = centralData?.workItemsWithOrganizationId.filter((workItem) => workItem.revisions[workItem.revisions.length - 1].fields["System.TeamProject"] === projectData?.name && workItem.organizationId === projectData?.organizationId && user.id.includes(workItem.revisions[workItem.revisions.length - 1].fields["System.AssignedTo"]?.id||''))
            const completedWorkItem = workItems?.filter((workItem) => workItem.revisions[workItem.revisions.length - 1].fields["System.State"] === 'Done')
            if (projectData) projects.push({
                ...projectData,
                userTotalWorkItems: workItems?.length || 0,
                userCompletedWorkItems: completedWorkItem?.length || 0,
                workItems: workItems?.map((workItem) => ({ ...workItem, ... workItem.revisions[workItem.revisions.length - 1] })) || []
            })
        })
        //filter projects
        if (filter) {
            projects = projects.filter((project) => {
                return project.projectStatus === filter.projectStatus
            })

        }


        return projects

    }



    return {
        getProjectsByUserId,
        listProjects
    };
}
export function useProjectsHoursAPI() {

    const {
        getProjectsByUserId
    } = useProjectsAPI()
    const api = useRestAPI()

    const {
        centralData
    } = useCentralAPI({
        trigger:false
    })




    const getProjectsandhoursByUserId =async ({ userOriginId, filter = {
        projectStatus: 'inProgress'
    } }: {
        userOriginId: string,
        filter?: {
            projectStatus?: 'completed' | 'inProgress' | 'onHold' | 'dropped',
        }
    }) => {

        const projects = getProjectsByUserId({ userOriginId, filter })
        const projectWithHours = projects.map((project) => {
            return {
                ...project,
                hours: 0
            }
        })
        await Promise.all(projectWithHours.map(async (project) => {
            const projectHour = await Promise.all(project.workItems.filter((workItem) => workItem.revisions[workItem.revisions.length - 1].fields["System.WorkItemType"] === 'Issue').map(async (workItem) => {
                const id = workItem.id
                const revisions = centralData?.workItemsWithOrganizationId.find((workItem) => workItem.id === id)?.revisions
                if(!revisions){
                    return 0
                }
                const hours = calculateWorkingHours(revisions)
                return hours

            }))
            const totalHours = projectHour.reduce((a, b) => a + b, 0)
            project.hours = totalHours
        }))
        return projectWithHours

    }



    return {
        getProjectsandhoursByUserId

    };
}

